export const mediaFilters = [
    {
        name: 'types',
        label: 'Type',
        type: 'checkbox',
        allow: ['interactive_id', 'user', 'shares', '360', 'public'],
        filters: [
            {
                text: 'Any',
                value: { type: 'image,video,document,before_after,audio,other' },
                mode: 'single',
            },
            {
                icon: 'video',
                text: 'Videos',
                value: { type: 'video' },
                mode: 'multiple',
                showText: false,
            },
            {
                icon: 'image',
                text: 'Images',
                value: { type: 'image' },
                mode: 'multiple',
                showText: false,
            },
            {
                icon: 'columns',
                text: 'Before/Afters',
                value: { type: 'before_after' },
                disabled: { interactive_id: true },
                mode: 'multiple',
                showText: false,
            },
            {
                icon: 'file',
                text: 'Documents',
                value: { type: 'document' },
                disabled: { interactive_id: true },
                mode: 'multiple',
                showText: false,
            },
            {
                icon: 'headphone',
                text: 'Audio',
                value: { type: 'audio' },
                mode: 'multiple',
                showText: false,
            },
        ],
    },
    {
        name: 'projections',
        label: 'Projection',
        type: 'radio',
        allow: ['interactive_id', 'type', 'user', 'shares', 'public'],
        filters: [
            {
                text: 'Any',
                value: { 360: null },
                mode: 'single',
            },
            {
                text: '360&deg; media',
                value: { 360: true },
                mode: 'single',
            },
            {
                text: 'Non 360&deg; media',
                value: { 360: false },
                mode: 'single',
            },
        ],
    },
    {
        name: 'source',
        label: 'Source',
        type: 'radio',
        allow: ['type', 'user', '360', 'shares', 'public'],
        filters: [
            {
                text: 'Any',
                value: { interactive_id: null },
                mode: 'single',
            },
            {
                text: 'Interactive captures',
                value: { interactive_id: true },
                deny: [{ type: 'before_after' }, { type: 'document' }],
                mode: 'single',
            },
            {
                text: 'CMS uploads',
                value: { interactive_id: false },
                mode: 'single',
            },
        ],
    },
    {
        name: 'flags',
        label: 'Status',
        type: 'radio',
        allow: ['interactive_id', 'type', 'user', 'shares', '360', 'comments'],
        filters: [
            {
                text: 'Any',
                value: { public: null },
                mode: 'single',
            },
            {
                text: 'Public',
                value: { public: true },
                mode: 'single',
            },
            {
                text: 'Private',
                value: { public: false },
                mode: 'single',
            },
        ],
    },
    {
        name: 'other',
        label: 'Other',
        type: 'checkbox',
        allow: ['interactive_id', 'type', '360', 'comments', 'public'],
        filters: [
            {
                text: 'Shared',
                value: { shares: true },
                mode: 'multiple',
            },
            {
                text: 'My Uploads',
                value: { user: ca.user.uuid },
                mode: 'multiple',
            },
        ],
    },
    {
        name: 'markup',
        label: 'Markup',
        type: 'radio',
        icon: 'pencil',
        text: 'Markup',
        //condition: [{ interactive_id: true }, {type: 'image'}],
        disabled: [
            { type: 'image,video,document,before_after,audio,other' },
            { type: 'video' },
            { type: 'before_after' },
            { type: 'document' },
            { 360: true },
        ],
        allow: ['interactive_id', 'type', 'user', 'public'],
        filters: [
            {
                text: 'All markup',
                value: { comments: true },
                mode: 'single',
            },
            {
                text: 'Incomplete markup',
                value: { comments: 'incomplete' },
                mode: 'single',
            },
            {
                text: 'Complete markup',
                value: { comments: 'complete' },
                mode: 'single',
            },
        ],
    },
];
